const STORAGE_KEY = 'anon_id';

/**
 * ID estable por navegador para enlazar visita anónima → lead → formulario.
 */
export function getOrCreateAnonymousId() {
  try {
    let id = localStorage.getItem(STORAGE_KEY);
    if (id && typeof id === 'string' && id.trim()) {
      return id.trim();
    }
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      id = crypto.randomUUID();
    } else {
      id = `anon_${Date.now()}_${Math.random().toString(36).slice(2, 14)}`;
    }
    localStorage.setItem(STORAGE_KEY, id);
    return id;
  } catch {
    return `anon_fallback_${Date.now()}`;
  }
}
